/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateCustomers} from '../api'

export const useMutationUpdateCustomers = createReactQueryMutationHook('updateCustomers', updateCustomers)
